import React from "react";
import "../LatestLocals/LatestLocal.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import { Image, Container, Col, Row } from "react-bootstrap";
import Local1 from "../../assets/local-1.png";
import Local2 from "../../assets/local-2.png";
import Local3 from "../../assets/local-3.png";
import Local4 from "../../assets/local-4.png";
import { Link } from "react-router-dom";

const LatestLocals = ({ voucherList }) => {
  return (
    <>
      <p className="latestloc-text tab-title">
        <span className="userline-title">Latest</span> Locals
      </p>
      <div className="d-flex mb-4">
        <p className="latestloc-text tab-hide-title">
          <span className="userline-title">Latest</span> Locals
        </p>
        <InputGroup className="search-bar">
          <InputGroup.Text>
            <MdSearch />
          </InputGroup.Text>
          <Form.Control placeholder="Search" />
          <Button variant="outline-secondary">Search</Button>
        </InputGroup>
        <Form.Select
          aria-label="Default select example"
          className="location-select sort-select"
        >
          <option>Sort</option>
          <option value="1">Latest</option>
          <option value="2">Price: Low to High</option>
          <option value="3">Price: High to Low</option>
        </Form.Select>
      </div>
      <div>
        {voucherList.length !== 0 ? (
          voucherList.map((list) => {
            return (
              <Row className="local-main" key={list.bu_id}>
                <Col md="2" className="local-1">
                  <Image loading="lazy" src={Local1} />
                </Col>
                <Col>
                  <p className="loc-detail-1">{list.category}</p>
                  <p className="loc-detail-2">{list.voucher_name}</p>
                  <p className="loc-detail-3">by Bijou Lash Extensions</p>
                  <div className="d-flex">
                    <p className="loc-price-1">${list.voucher_actual_price}</p>
                    <p className="loc-price-2">${list.voucher_offer_price}</p>
                    <p className="loc-price-offer">{list.offered_percent}% OFF</p>
                  </div>
                </Col>
                <Col>
                  <Link className="view-main" to="/voucherdetail">
                    <p className="view">View Details</p>
                  </Link>
                </Col>
                <div className="tag-main">
                  <p className="ribben">VOUCHER</p>
                </div>
              </Row>
            );
          })
        ) : (
          <p className="NoDataAvailable">No data available!</p>
        )}
        <div className="text-center">
          <Button variant="primary" className="green-btn">
            Load More
          </Button>
        </div>
      </div>
    </>
  );
};

export default LatestLocals;
